import type { ResourceKey, Settlement, SettlementInventory, ToolItem } from '../types';

export function recordProduced(settlement: Settlement, key: ResourceKey, amount: number): void {
    if (!settlement.resourceStats || amount <= 0) return;
    settlement.resourceStats.produced[key][settlement.resourceStats.index] += amount;
}

export function recordConsumed(settlement: Settlement, key: ResourceKey, amount: number): void {
    if (!settlement.resourceStats || amount <= 0) return;
    settlement.resourceStats.consumed[key][settlement.resourceStats.index] += amount;
}

export function takeTools(settlement: Settlement, count: number): ToolItem[] {
    if (count <= 0) return [];
    const taken = settlement.inventory.tools.splice(0, count);
    recordConsumed(settlement, 'tools', taken.length);
    return taken;
}

export function addTools(settlement: Settlement, tools: ToolItem[]): void {
    if (!tools.length) return;
    settlement.inventory.tools.push(...tools);
    recordProduced(settlement, 'tools', tools.length);
}

export function addToolsUntracked(settlement: Settlement, tools: ToolItem[]): void {
    if (!tools.length) return;
    settlement.inventory.tools.push(...tools);
}

export function addInventory(
    settlement: Settlement,
    key: keyof Omit<SettlementInventory, 'tools'>,
    amount: number,
): void {
    if (!Number.isFinite(amount) || amount <= 0) return;
    settlement.inventory[key] += amount;
    recordProduced(settlement, key, amount);
}

export function addInventoryUntracked(
    settlement: Settlement,
    key: keyof Omit<SettlementInventory, 'tools'>,
    amount: number,
): void {
    if (!Number.isFinite(amount) || amount <= 0) return;
    settlement.inventory[key] += amount;
}

export function removeInventory(
    settlement: Settlement,
    key: keyof Omit<SettlementInventory, 'tools'>,
    amount: number,
): number {
    if (!Number.isFinite(amount) || amount <= 0) return 0;
    const current = settlement.inventory[key];
    const removed = Math.min(current, amount);
    settlement.inventory[key] = current - removed;
    recordConsumed(settlement, key, removed);
    return removed;
}

export function removeInventoryUntracked(
    settlement: Settlement,
    key: keyof Omit<SettlementInventory, 'tools'>,
    amount: number,
): number {
    if (!Number.isFinite(amount) || amount <= 0) return 0;
    const current = settlement.inventory[key];
    const removed = Math.min(current, amount);
    settlement.inventory[key] = current - removed;
    return removed;
}
